module.exports = __webpack_public_path__ + "static/media/qr_update_pvconnect.a98c4a87.jpg";